import { Location } from '@angular/common';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from '../app-component-base';

@Component({
    selector: 'app-order-tracking',
    templateUrl: './order-tracking.component.html',
    styleUrls: ['./order-tracking.component.scss']
})
export class OrderTrackingComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) public grid: GridComponent;
    pattern = new CustomPattern();
    isFormLoading = false;
    shipmentGridItems: any = {
        data: [],
        total: 0
    };
    orderId: any;
    trackingData: any;
    trackingSummaryData: any;
    counter = 0;
    shipmentEmails: any;
    emailsParam = '';
    isEmailMaxLimit = false;
    isEmailInvalid = { isValid: false, email: '' };

    constructor(
        injector: Injector,
        public location: Location,
        private activatedRoute: ActivatedRoute,
        private commonService: CommonService,
        private toastr: ToastrService,
    ) {
        super(injector);
    }

    ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        }
        this.loadTrackingSummary();
        this.loadTrackingDetails();
    }

    onBack() {
        this.location.back();
    }

    loadTrackingSummary() {
        this.isFormLoading = true;
        this.commonService.getTrackingSummary({ id: this.orderId }).subscribe((response: any) => {
            this.isFormLoading = false;
            if (response.isSuccess) {
                this.trackingSummaryData = response.data;
                this.shipmentGridItems.data = response.data.getFinalBol ? response.data.getFinalBol : [];
                this.shipmentEmails = this.trackingSummaryData.shipmentAlertEmails;
            } else {
                this.toastr.error(response.errors || 'Something Went wrong.');
            }
        });
    }

    loadTrackingDetails() {
        this.commonService.getOrderTrackingDetails(this.orderId).subscribe(response => {
            if (response.isSuccess) {
                this.trackingData = response.data;
            } else {
                this.toastr.error(response.errors || 'Something Went wrong.');
            }
        });
    }

    onShowTrackingIcons(iconName: string) {
        const iconVal = iconName.toLowerCase();
        switch (iconVal) {
            case CommonConstants.trackingIconConstants.shipmentCreated:
                return 'assets/images/shipmentCreated.svg';
            case CommonConstants.trackingIconConstants.inTransit:
                return 'assets/images/inTransit.svg';
            case CommonConstants.trackingIconConstants.pending:
                return 'assets/images/pending.svg';
            case CommonConstants.trackingIconConstants.delivered:
                return 'assets/images/delivered.svg';
            case CommonConstants.trackingIconConstants.failed:
                return 'assets/images/failed.svg';
            default:
                return '';
        }
    }

    onSubmitEmails() {
        const emailArray = this.shipmentEmails.split(';');
        if (emailArray.length <= 5) {
            this.isEmailMaxLimit = false;
            emailArray.forEach(element => {
                const str = element.trim();
                const resp = str.match(this.pattern.email);
                if (resp === null) {
                    this.isEmailInvalid.email = str;
                    this.isEmailInvalid.isValid = true;
                } else {
                    this.emailsParam += str + ';';
                }
            });
            if (!this.isEmailInvalid.isValid) {
                this.emailsParam = this.emailsParam.replace(/;\s*$/, '');
                const payload = {
                    ShipmentId: this.trackingData[0].shipmentId,
                    ShipmentAlertEmails: this.emailsParam
                };
                this.isFormLoading = true;
                this.commonService.shipmentAlertEmails(payload).subscribe((response: any) => {
                    this.isFormLoading = false;
                    this.emailsParam = '';
                    if (response.isSuccess) {
                        this.toastr.success(response.errors);
                    } else {
                        this.toastr.error(response.errors);
                    }
                });
            }
        } else {
            this.isEmailMaxLimit = true;
        }
    }

    onKey(event: any) {
        if (event) {
            this.isEmailInvalid.email = '';
            this.isEmailInvalid.isValid = false;
        }
    }

    onSendEmails() {
        this.isFormLoading = true;
        this.commonService.getSendShipmentAlertEmails(this.orderId).subscribe((response: any) => {
            this.isFormLoading = false;
            if (response.isSuccess) {
                this.toastr.success(response.errors);
            } else {
                this.toastr.error(response.errors);
            }
        });
    }

}
